import { render, staticRenderFns } from "./gc-popup-schedule-note.vue?vue&type=template&id=0cb8670c"
import script from "./gc-popup-schedule-note.vue?vue&type=script&lang=js"
export * from "./gc-popup-schedule-note.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-schedule-note.vue?vue&type=style&index=0&id=0cb8670c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports